import store from '../store'

export default {
    // 将add复制到origin，origin不包含的属性则不复制
    mergeObj(origin, add) {
        if (add === null || typeof add !== 'object') {
            return origin
        }

        var keys = Object.keys(origin)
        var i = keys.length
        while (i--) {
            if (add.hasOwnProperty(keys[i])) {
                origin[keys[i]] = add[keys[i]]
            }
        }
        return origin
    },
    //将add合并到origin，origin包含的属性则不复制
    combineObj(origin, add) {
        if (add === null || typeof add !== 'object') {
            return origin
        }

        var keys = Object.keys(add)
        var i = keys.length
        while (i--) {
            if (!origin.hasOwnProperty(keys[i])) {
                origin[keys[i]] = add[keys[i]];
            }
        }
        return origin;
    },
    //ids
    combineKeys(obj) {
        if (obj === null || typeof obj !== 'object') {
            return ""
        }
        var str = "";
        var keys = Object.keys(obj)
        var i = keys.length
        while (i--) {
            str += keys[i] + ",";
        }
        if (str != '') {
            if (str.substr(str.length - 1) == ',') {
                str = str.substr(0, str.length - 1)
            }
        }
        return str;
    },
    //获取部分字段
    getProps(obj, filters) {
        if (obj == null || !(obj instanceof Array)) {
            return obj;
        }
        if (!(filters instanceof Array) || filters.length == 0) {
            return obj;
        }
        var rst = [];
        for (let o of obj) {
            var add = {};
            for (let prop of filters) {
                add[prop] = o[prop];
            }
            rst.push(add);
        }
        return rst;
    },
    //计算表格奇偶颜色
    tabCellStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
            return "td-even";
        } else if (rowIndex % 2 == 1) {
            return "td-odd";
        }
    },
    formatDateUtil(fmt, date) {
        if (typeof date === "string" || typeof date === "number") {
            try {
                date = new Date(date)
            } catch (e) {
                alert("不错正确日期")
                return null
            }
        }
        if (date == null) {
            date = new Date();
        }
        var o = {
            "M+": date.getMonth() + 1, //月份   
            "d+": date.getDate(), //日   
            "h+": date.getHours(), //小时   
            "m+": date.getMinutes(), //分   
            "s+": date.getSeconds(), //秒   
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
            "S": date.getMilliseconds(), //毫秒 
            "W": this.getWeekDay(date) //星期几
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            }
        }
        return fmt;
    },
    getWeekDay(date) {
        var d2 = date.getDay();
        switch (d2) {
            case 0:
                d2 = '星期日';
                break;
            case 1:
                d2 = '星期一';
                break;
            case 2:
                d2 = '星期二';
                break;
            case 3:
                d2 = '星期三';
                break;
            case 4:
                d2 = '星期四';
                break;
            case 5:
                d2 = '星期五';
                break;
            case 6:
                d2 = '星期六';
                break;
        }
        return d2;
    },
    ifNullThen(data, initValue) {
        if (data == null || data == '') {
            return initValue;
        }
        return data;
    },
    //N天后的现在
    addDate(data, a) {  
        var current = data.getTime();
        var future = current + a * 24 * 3600 * 1000;
        return new Date(future)  
    },
    stringFormat(str, args) {
        var result = str;
        for (var key in args) {
            if (args[key] != undefined) {
                var reg = new RegExp("({" + key + "})", "g");
                result = result.replace(reg, args[key]);
            }
        }
        return result;
    },
	timestampToDate(timestamp) {
		if (typeof timestamp === 'string') {
			timestamp = timestamp * 1;
		}
		let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
		// let h = date.getHours() + ':';
		// let m = date.getMinutes() + ':';
		// let s = date.getSeconds();
		let datess = Y + M + D;
		return datess;
	},
    //导出文件
    exprotExcels(url, props) {
        var form = $("<form></form>")
        form.attr('action', url)
        form.attr('method', 'post')
        var keys = Object.keys(props)
        var i = keys.length
        while (i--) {
            var input = $('<input type="hidden" />');
            input.attr('name', keys[i]);
            input.attr('value', props[keys[i]]);
            form.append(input);
        }
        $(document.body).append(form);
        form.submit();
    },
    arraySort(arr, key, sort) {
        if (!Array.isArray(arr) || arr.length == 0 || key == null || key == "" || sort == null || sort == "") {
            return arr
        }
        if (sort == "asc") {
            arr.sort(function(a, b) {
                return a[key] - b[key]
            })
        } else if (sort == "desc") {
            arr.sort(function(a, b) {
                return b[key] - a[key]
            })
        }
        return arr
    },
    //将cloned复制到origin
    cloneObj(cloned) {
        var newObject = null;
        if (cloned instanceof Array) {
            newObject = [];
            for (var id = 0; id < cloned.length; id++) {
                newObject.push(this.cloneObj(cloned[id]));
            }
        } else if (typeof cloned == "object") {
            const keys = Object.keys(cloned) //得到obj里所有的keys

            newObject = {};

            for (let i = 0; i < keys.length; i++) {
                const key = keys[i]
                if (key.indexOf("_") == 0) {
                    continue;
                }
                if (cloned[key] == null) {
                    continue;
                }
                if (typeof cloned[key] === 'object') {
                    newObject[key] = this.cloneObj(cloned[key])
                } else {
                    newObject[key] = cloned[key]
                }
            }
        } else {
            newObject = cloned
        }

        return newObject
    },
    //导出文件
    exprotExcel(url, props) {
        var form = document.createElement("form");
        form.setAttribute('action', url)
        form.setAttribute('method', 'post')
        if (props != null) {
            var keys = Object.keys(props)
            var i = keys.length
            while (i--) {
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = keys[i];
                input.value = props[keys[i]];
                form.appendChild(input);
            }
        }
        document.body.appendChild(form);
        form.submit();
    },

    trimEnd(v, c) {
        if (c == null || c == "") {
            var str = v;
            var rg = /s/;
            var i = str.length;
            while (rg.test(str.charAt(--i)));
            return str.slice(0, i + 1);
        } else {
            var str = v;
            var rg = new RegExp(c);
            var i = str.length;
            while (rg.test(str.charAt(--i)));
            return str.slice(0, i + 1);
        }
    },

    getDict(type){
        if(store.getters.dicts[type]){
            return store.getters.dicts[type];
        }else{
            return [];
        }
    },
    clearEveryKey(obj){
        if (obj === null || typeof obj !== 'object') {
            return {}
        }

        for(var a in obj){
            obj[a] = "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js